import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Select from './Select';

import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import {
  clearDepartaments,
  getDepartaments,
} from '../../../../actions/hcm/Organization';

const HcmDepartmentSelect = ({
  dispatchGetDepartaments,
  dispatchClearDepartaments,
  departments,
  isLoading,
  isMulti,
  input,
  meta,
  organizationId,
  ...rest
}) => {
  useLayoutEffect(() => {
    if (organizationId) {
      dispatchGetDepartaments({ organizationId });
    }

    return () => {
      dispatchClearDepartaments();
    };
  }, [organizationId]);

  return (
    <Select
      options={departments}
      isLoading={isLoading}
      isMulti={isMulti}
      input={input}
      meta={meta}
      {...rest}
    />
  );
};

HcmDepartmentSelect.propTypes = {
  dispatchGetDepartaments: PropTypes.func.isRequired,
  dispatchClearDepartaments: PropTypes.func.isRequired,
  organizationId: PropTypes.number,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  departments: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  meta: metaPropTypes,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

HcmDepartmentSelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  organizationId: null,
  isLoading: false,
  isMulti: false,
  departments: [],
  isDisabled: false,
};

const mapStateToProps = ({ HcmUnit }) => ({
  departments: HcmUnit.Organization.getIn(['departaments', 'content']).map(
    (department) => ({
      value: department.get('id'),
      label: department.get('name'),
    }),
  ),
  isLoading: HcmUnit.Organization.getIn(['departaments', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetDepartaments: getDepartaments,
  dispatchClearDepartaments: clearDepartaments,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HcmDepartmentSelect);
